<template>
    <div>
        <Head title="Customers"/>
        <h1 class="mb-8 text-3xl font-bold">Customers</h1>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <label class="block mt-4 text-gray-700">Brand:</label>
                <select v-model="form.brand" class="form-select mt-1 w-full">
                    <option :value="null"/>
                    <option v-for="(id, name) in brands" :value="id">{{ name }}</option>
                </select>
            </search-filter>
        </div>

        <h3 class="mb-3">Total customers count: <b>{{total}}</b></h3>

        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">ID / Mgmt ID</th>
                    <th class="pb-4 pt-6 px-6">Brand</th>
                    <th class="pb-4 pt-6 px-6">Source</th>
                    <th class="pb-4 pt-6 px-6">Email</th>
                    <th class="pb-4 pt-6 px-6">Status</th>
                    <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
                </tr>
                <tr v-for="customer in customers" :key="customer.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="`/customers/${customer.id}/edit`">
                            {{ customer.id }} / {{ customer.mgmt_id }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="`/customers/${customer.id}/edit`">
                            {{ customer.brand_name }}
                            <icon v-if="customer.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/customers/${customer.id}/edit`" tabindex="-1">
                            {{ customer.traffic_source }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/customers/${customer.id}/edit`" tabindex="-1">
                            {{ customer.email }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/customers/${customer.id}/edit`" tabindex="-1">
                            {{ customer.status }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/customers/${customer.id}/edit`" tabindex="-1">
                            {{ customer.created_at }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link class="flex items-center px-4" :href="`/customers/${customer.id}/edit`" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="customers.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">No customers found.</td>
                </tr>
            </table>
            <div class="bg-white p-4 flex items-center flex-wrap">
                <nav aria-label="Page navigation">
                    <ul class="inline-flex">
                        <li v-for="link in paginator.links">
                            <Link :class="[link.active ? 'bg-indigo-600 text-white' : 'text-indigo-600 bg-white']" class="px-4 py-2 transition-colors duration-150 border border-indigo-600 focus:shadow-outline" :href="`${link.url}`" v-if="link.url">
                                {{link.label}}
                            </Link>
                            <Link class="px-4 py-2 transition-colors duration-150 border border-indigo-600 focus:shadow-outline" :href="`#`" v-else>
                                {{link.label}}
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        SearchFilter,
    },
    layout: Layout,
    props: {
        brands: Object,
        filters: Object,
        customers: Array,
        paginator: Object,
        total: Number
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                brand: this.filters.brand,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/customers', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
